import Xyz from "./xyz";

function googlebase() {
  return new Xyz({
    attribution: "ThanksToGoogleMap",
    url: "https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}",
    maxZoom: 15,
  });
}

export default googlebase;
